var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select"},[_vm._t("default"),_vm._v(" "),_c('fa',{staticClass:"select-chevron",attrs:{"icon":['fal', 'chevron-down'],"size":"sm"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }